import { render, staticRenderFns } from "./p-card.vue?vue&type=template&id=42412471"
import script from "./p-card.vue?vue&type=script&lang=js"
export * from "./p-card.vue?vue&type=script&lang=js"
import style0 from "./p-card.vue?vue&type=style&index=0&id=42412471&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports